import PropTypes from 'prop-types';
import { Divider, List, ListItem, ListItemText } from '@mui/material';
import theme from 'theme';

import { doc, updateDoc } from 'firebase/firestore';
import { useFirestore } from 'utils/firebase';
import { SubHeader } from './SubHeader';
import { RequestItem } from './RequestItem';

const itemMapper = {
  request: {
    component: args => <RequestItem key={args.item.id} {...args} />,
  },
};

const NotificationList = ({ className, notifications, user }) => {
  const database = useFirestore();

  const handleRemove = async id => {
    const update = user.notifications.filter(e => e.id !== id);
    return updateDoc(doc(database, 'users', user.uid), { notifications: update });
  };

  return (
    <List
      sx={{
        width: '400px',
        maxWidth: '100%',
        maxHeight: 400,
        position: 'relative',
        overflow: 'auto',
        paddingBottom: theme.spacing(1),
      }}
      className={className}
      subheader={<SubHeader notifications={notifications} user={user} />}
      aria-labelledby="Notifications"
    >
      <Divider />

      {notifications.length ? (
        [...notifications].reverse().map(item =>
          itemMapper[item.type].component({
            handleRemove,
            item,
          }),
        )
      ) : (
        <ListItem>
          <ListItemText>No new notifications</ListItemText>
        </ListItem>
      )}
    </List>
  );
};

NotificationList.propTypes = {
  user: PropTypes.object,
  className: PropTypes.string,
  notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
};

NotificationList.defaultProps = {
  className: '',
  user: {},
};

export default NotificationList;
